import React, {Component} from 'react';
import config from "../../config";
import {BreadCumb, NavBar,CreateQueryModal,CreateQueryManagerModal,TimeOut} from "../../components";
import {ApiClient} from "../../libs/apiClient";
import $ from 'jquery';
import {DISPATCH_ID, SERVICE_RESPONSE} from "../../libs/utils/Const";
import {connect} from "react-redux";
import {QueryModel} from '../../components/NewOrder';

let apiClient = ApiClient.getInstance();

class QueryView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query:[],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'))
        };
    }

    async componentDidMount(): void {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liConsultas");
        
    }

    createDocument = () => {
        $('#queryModal').modal({backdrop: 'static', keyboard: false}, 'show');
    };

    createManagerDocument = () => {
        $('#queryManagerModal').modal({backdrop: 'static', keyboard: false}, 'show');
    };

    createManagerDocument = async () => {

        const { notificationReducer: {showAlert}, enableSpinner, QCategory} = this.props;

        enableSpinner(true);
        let getQueryManagerResponse = await apiClient.getSearchFormater();
        enableSpinner(false);
     

        if (!Array.isArray(getQueryManagerResponse.data.searchFormater) ) {
            showAlert({type: 'error', message: 'Ocurrió un error al consultar la Información'});
            return;
        }

        if (getQueryManagerResponse.data.length === 0) {
            showAlert({type: 'info', message: 'No hay Información por mostrar'});
            return;
        }

        this.setState({
            query: getQueryManagerResponse.data
        });
        $('#queryManagerModal').modal({backdrop: 'static', keyboard: false}, 'show');
    };
 

    
    render() {
        const { notificationReducer: {showAlert}, enableSpinner}= this.props
        const {query ,_user}= this.state
       
        return (
            <div className="content">
                <NavBar props={this.props} _user={_user}/>
                <BreadCumb subitem1={'CONSULTAS'} url1={'#'}/>
                {/* <CreateQueryModal enableSpinner={enableSpinner} showAlert={showAlert}/> */}
                <CreateQueryManagerModal query={query} enableSpinner={enableSpinner} showAlert={showAlert}/>
                <TimeOut/>
                <div style={{marginLeft: "4rem", marginBottom: "12rem"}}>

                    <h2 className="md-display-1">
                        <a id="linkOrdProv" className="text-muted">
                            &nbsp;CONSULTAS
                        </a>
                    </h2>
                        <div className='form-row'>

                                 {/* <button className="btn btn-timbra-one btn-outline-secondary"
                                style={{width:252, borderColor: "#A7A6A5"}} onClick={this.createDocument}>
                                    <i className="far fa-file"></i> Nueva Consulta
                                </button>
                                &nbsp;&nbsp;  */}
                                <br className="hide-pc"/>
                                <button className="btn btn-outline-secondary btn-timbra-one" 
                                style={{width:250, borderColor: "#A7A6A5"}} onClick={this.createManagerDocument}>
                                    <i className="far fa-file"></i> Query Manager
                                </button>

                        </div>

                </div>
            </div>
        );
    }
}
const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value})
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QueryView);